import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router'
import { ComunModule } from '../comun.module'
import { NoDataComponent } from './no-data.component';

const routes: Routes = [
  {
    path: '',
    component: NoDataComponent
  }
]

export const routing = RouterModule.forChild(routes)
@NgModule({
  imports: [
    routing,
    ComunModule,
  ],
  declarations: [NoDataComponent]
})
export class NoDataModule { }
